module.exports = __webpack_public_path__ + "img/pack-title01.be9bda58.png";